import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "../../components/grid";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO, } from "../../utils/const/estilos-const";
import ModalConfirmar from "../../components/modal-confirmar";
import "../../style/style-cargando.css";
import {
  INT_TIPO_USUARIO_ADMINISTRADOR_WEB,
} from "../../utils/const/int-const";
// import { TRUE } from "../../utils/const/bool-const";
import cargandoCard from "../../components/cargando-card";
import SinAccesoCard from "../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
// import { deshabilitarArea, obtenerListaArea } from "../../api/area";
import { deshabilitarRespuestaChecklist, obtenerChecklistRealizadoPorUsuarioMovil } from "../../api/api-checklist";
import { sharedNextPage } from "../../utils/shared-functions";
import moment from "moment";
import DatePicker from "react-widgets/DatePicker";
import { useTranslation } from "react-i18next";
import { COLOR_AZUL_MAIN } from "../../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_TIPO_USUARIO_CHECKLIST } from "../../utils/const/string-const";
import { obtenerPermisos } from "../../api/api-permisos";
import { PAGE_ID } from "../../utils/const/pages-const";
import ProcessingDialog from "../../components/processing-dialog";

const idTipoUsuario = localStorage.getItem(STRING_TIPO_USUARIO_CHECKLIST);
const idSubTipoUsuarioWeb = localStorage.getItem(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST);

export default function RespuestasChecklist() {
  const { t } = useTranslation();
  const headers = [
    { key: "acciones", title: t('column_acciones') },
    { key: "id", title: "CODIGO", visible: false, },
    { key: "idChecklist", title: "ID CHECKLIST", visible: false, filter: true, editLabel: true, },
    { key: "nombreChecklist", title: t('column_nombre_checklist'), visible: true, filter: true, },
    { key: "codigoVehiculo", title: "CODIGO VEHICULO", visible: false, filter: true, },
    { key: "valueVehiculo", title: "VALUE VEHICULO", visible: false, filter: true, },
    { key: "labelVehiculo", title: t('column_vehiculo'), visible: true, filter: true, },
    { key: "odometroActual", title: t('column_odometro_actual'), visible: true, filter: true, },
    { key: "odometroProximo", title: t('column_odometro_proximo'), visible: true, filter: true, },
    { key: "fechaActualChecklist", title: t('column_fecha_actual_checklist'), visible: true, filter: true, },
    { key: "fechaProximoChecklist", title: t('column_fecha_proximo_checklist'), visible: true, filter: true, },
    { key: "codigoConductor", title: "CODIGO CONDUCTOR", visible: false, filter: true, },
    { key: "valueConductor", title: "VALUE CONDUCTOR", visible: false, filter: true, },
    { key: "labelConductor", title: t('column_conductor'), visible: true, filter: true, },
    { key: "idArea", title: "ID AREA", visible: false, filter: true, editLabel: true, },
    { key: "nombreArea", title: t('column_nombre_area'), visible: true, filter: true, },
    { key: "idCiudad", title: "ID CIUDAD", visible: false, filter: true, editLabel: true, },
    { key: "nombreCiudad", title: t('column_ciudad'), visible: true, filter: true, },
    { key: "idTipoChecklist", title: "ID TIPO CHECKLIST", visible: false, filter: true, editLabel: true, },
    { key: "tipoChecklist", title: t('column_tipo_checklist'), visible: true, filter: true, },
    { key: "idTipoVehiculo", title: "ID TIPO VEHICULO", visible: false, filter: true, editLabel: true, },
    { key: "tipoVehiculo", title: t('column_tipo_vehiculo'), visible: true, filter: true, },
    { key: "idMarcaVehiculo", title: "ID MARCA VEHICULO", visible: false, filter: true, editLabel: true, },
    { key: "marcaVehiculo", title: t('column_marca_vehiculo'), visible: true, filter: true, },
    { key: "idTipoCarroceria", title: "ID TIPO CARROCERIA", visible: false, filter: true, editLabel: true, },
    { key: "tipoCarroceria", title: t('column_tipo_carroceria'), visible: true, filter: true, },
    { key: "idTipoCombustible", title: "ID TIPO COMBUSTIBLE", visible: false, filter: true, editLabel: true, },
    { key: "tipoCombustible", title: t('column_tipo_combustible'), visible: true, filter: true, },
    { key: "fechaProceso", title: t('column_fecha_proceso'), visible: true, filter: true },
  ];
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [listaElementos, setListaElementos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);

  const [fechaInicio, setFechaInicio] = useState(new Date(moment().clone().startOf("week").format("YYYY-MM-DD")));
  const [fechaFin, setFechaFin] = useState(new Date(moment().clone().endOf("week").format("YYYY-MM-DD")));
  const [colorMain, setColorMain] = useState(COLOR_AZUL_MAIN);

  const [btnBuscar, setBtnBuscar] = useState(false);

  const [sendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let permiso = null;
      let lista = [];
      let objEnviar = {};
      objEnviar.fechaInicio = moment(fechaInicio).format('YYYY-MM-DD');
      objEnviar.fechaFin = moment(fechaFin).format('YYYY-MM-DD');
      lista = await obtenerChecklistRealizadoPorUsuarioMovil(objEnviar);
      const colorBase = localStorage.getItem(STRING_COLOR_PRIMARIO);
      if (colorBase !== null) {
        setColorMain(colorBase);
      }
      if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnBuscar(true);
        setTieneAccesoAlModulo(true);
      }
      if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        const objEnviar = {
          idSubTipoUsuarioWeb: idSubTipoUsuarioWeb,
        };
        const permisos = await obtenerPermisos(objEnviar);
        if (permisos.error === false && Array.isArray(permisos.data) && permisos.data.length > 0) {
          permiso = permisos.data[0];
          const permisosInfo = JSON.parse(permisos.data[0].permisos);
          // console.log('permisosInfo');
          // console.log(permisosInfo);
          const permisosPage = permisosInfo.find(e => e.value === PAGE_ID.RESPUESTAS_CHECKLIST);
          // console.log('permisosPage');
          // console.log(permisosPage);
          setTieneAccesoAlModulo(permisosPage.checked === true);
        }
      }
      agregarAccionesALista(lista, permiso);

      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const agregarAccionesALista = (lista, permiso) => {
    try {
      let btnDeshabilitar = false;
      let btnVer = false;
      if (permiso !== null) {
        const parsePermisos = JSON.parse(permiso.permisos);
        const permisosRespuestasChecklist = parsePermisos.find(e => e.value === PAGE_ID.RESPUESTAS_CHECKLIST);
        if (permisosRespuestasChecklist !== undefined) {
          const acciones = permisosRespuestasChecklist.acciones;
          if (acciones !== undefined) {
            const ver = acciones.find(e => e.value === 'btn_ver');
            if (ver !== undefined) {
              btnVer = ver.checked;
            }
            const deshabilitar = acciones.find(e => e.value === 'btn_deshabilitar');
            if (deshabilitar !== undefined) {
              btnDeshabilitar = deshabilitar.checked;
            }
          }
        }
        let listaFiltrada = [];
        if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          listaFiltrada = lista;
        }
        if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          if (permiso !== null) {
            const parseUnidades = JSON.parse(permiso.unidades);
            // console.log('parseUnidades');
            // console.log(parseUnidades);
            for (let i = 0; i < lista.length; i++) {
              const unidad = lista[i];
              // console.log('unidad');
              // console.log(unidad);
              if (parseUnidades.some(e => e.value === unidad.valueVehiculo) || unidad.valueVehiculo === '') {
                // console.log('unidad agregar listaFiltrada');
                // console.log(unidad);
                listaFiltrada.push(unidad);
              }
            }
          }
        }
        // console.log('lista');
        // console.log(listaFiltrada);
        lista = listaFiltrada;
      }
      const objVer = {
        label: t('btn_ver'),
        color: "green",
        onClick: (param) => verElementoSelected(param),
      };
      const objDeshabilitar = {
        label: t('btn_deshabilitar'),
        color: "red",
        onClick: (param) => cambiarEstado(param),
      };
      for (let i = 0; i < lista.length; i++) {
        let acciones = [];
        if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          acciones.push(objVer);
          acciones.push(objDeshabilitar);
        }
        if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          if (btnVer === true) {
            acciones.push(objVer);
          }
          if (btnDeshabilitar === true) {
            acciones.push(objDeshabilitar);
          }
        }
        lista[i].acciones = acciones;
      }
      setListaElementos(lista);
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const verElementoSelected = (data) => {
    try {
      // console.log("editarElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t('titulo_detalle_respuestas_checklist');
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("detalle-respuestas-checklist", obj, history);
    } catch (err) {
      console.log("editarElementoSelected err");
      console.log(err);
    }
  };

  const cambiarEstado = async (data) => {
    try {
      // console.log("cambiarEstado");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstado err");
      console.log(err);
    }
  };

  const handleAtrasClick = () => {
    history.goBack();
  }

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  }

  const handleCancelModal = () => {
    setModalConfirmarDeshabilitarVisible(false);
  }

  const handleConfirmModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    // console.log('elementoSelected');
    // console.log(elementoSelected);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    setSendRequest(true);
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      let deshabilitado = await deshabilitarRespuestaChecklist(objEnviar);
      setSendRequest(false);
      // console.log('creado');
      // console.log(creado);
      if (deshabilitado === true) {
        alert(t('alert_se_proceso_correctamente'));
        reset();
      }
      if (deshabilitado === false) {
        alert(t('alert_no_se_pudo_procesar'));
      }
    }
  }

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return SinAccesoCard();
      }
      return (
        <div className="pt-4 px-4">
          <div className=" flex justify-between">
            <label
              style={{
                // paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              {t('titulo_lista_respuestas_checklist')}
            </label>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                {t('btn_atras')}
              </button>
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                <Settings />
              </button> */}
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label>{t('label_fecha_inicio')}</label>
              <DatePicker
                defaultValue={fechaInicio}
                value={fechaInicio}
                valueFormat={{ dateStyle: "medium" }}
                onChange={(date) => setFechaInicio(date)}
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label>{t('label_fecha_fin')}</label>
              <DatePicker
                defaultValue={fechaFin}
                value={fechaFin}
                valueFormat={{ dateStyle: "medium" }}
                onChange={(date) => setFechaFin(date)}
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3"></div>
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              {btnBuscar === true && (
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={() => reset()}
                  style={{ backgroundColor: colorMain }}
                >
                  {t('btn_buscar')}
                </button>
              )}
            </div>
          </div>
          <br />
          <Grid rows={listaElementos} headers={headers} />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={handleCancelModal}
            onConfirm={handleConfirmModal}
            message={t('alert_esta_seguro_de_deshabilitar_respuesta_checklist')}
          />
          <ProcessingDialog visible={sendRequest} message={t("alert_procesando_solicitud")} />
        </div>
      );
    } catch (err) {
      console.log('ListarArea render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
